import angular from 'angular';
import uiRouter from 'angular-ui-router';
import StoreAddComponent from './storeAdd.component';

const storeAddModule = angular.module('tinaba.components.store.add', [
  uiRouter,
])

.config(($stateProvider) => {
  'ngInject';
  $stateProvider
    .state('store.add', {
      url: '/storeadd',
      template: '<store-add></store-add>',
    });
})
.component('storeAdd', StoreAddComponent);


export default storeAddModule;



/** WEBPACK FOOTER **
 ** ./client/app/components/store/storeAdd/storeAdd.js
 **/